export function initStackWrapper() {
    // Cerchiamo l'hook nel DOM
    if (document.querySelector('.js-stack-wrapper')) {
        // Caricamento dinamico della logica pesante solo se serve
        import('./stack_wrapper.js')
            .then(module => module.default())
            .catch(err => console.error("Errore caricamento Stack Wrapper:", err));
    }
}
